import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, map } from 'rxjs/operators';
import { MidjourneyUserDetail, MidjourneyUserDetailResponse, Users } from '../models/users.model';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends BaseService<Users> implements OnDestroy {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  langId: number;
  API_URL = `${environment.apiUrl}/Users`;
  API_URUpdatePassword = `${environment.apiUrl}/accounts/UpdatePasswordFromUser`;
  countriesUrl = `./assets/country.json`;

    constructor(@Inject(HttpClient) http, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http, toastr, translationServices);

    }
  ngOnDestroy(): void {
  }

  getCountries(): Observable<any[]> {
    return this.http.get<any[]>(this.countriesUrl);
  }

  updateUserPassword$(model: any): Observable<void> {
    return this.http.post<void>(this.API_URUpdatePassword, model, this.httpOptions).pipe(
      catchError(err => {
        // Safely extract the error description from the response
        const errorDescription = err?.error?.errors?.[0]?.description || 'An unexpected error occurred.';
        
        // Show the extracted error message in the toaster
        this.toastr.error(errorDescription);
  
        // Rethrow the error to propagate it if necessary
        return throwError(() => new Error(errorDescription));
      }),
      map((body: any) => body)
    );
  }
   
}
